export function normalizeTagName(name) {
    return name
        .normalize('NFC')
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]/gu, '');
}
//# sourceMappingURL=normalize-tag-name.js.map